import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { AUTH_DETAILS, AUTH_TOKEN, MENU_ITEMS } from 'constants/AuthConstant';
import clientService from '../../services/ClientService';
import { useDispatch } from 'react-redux';



export const initialState = {
	loading: false,
	message: '',
	list:null,
}



export const plantListAll = createAsyncThunk('plant/list',async (data, { rejectWithValue }) => {
	
	try {
		const response = await clientService.getPlant()
		return response.data;
		
		
	} catch (err) {
		
		return rejectWithValue(err.response?.data?.message || 'Error')
	}
})


export const plantSlice = createSlice({
	name: 'plant',
	initialState,
	reducers: {
			
		plantList: (state, action) => {
			state.loading = true
			state.list = action.payload
		}
	},
	extraReducers: (builder) => {
		builder
			.addCase(plantListAll.pending, (state) => {
		
				state.loading = false
			})
			.addCase(plantListAll.fulfilled, (state, action) => {
				state.loading = true
				state.list = action.payload
			})
			
	},
})

export const { 
	plantList,
    
    
} = plantSlice.actions

export default plantSlice.reducer